import {BackendConfig, OccConfig, OccEndpoints} from '@spartacus/core';

export const aimoB2bOccConfig: AimoOccConfig = {
    backend: {
        occ: {
            endpoints: {
                cdcToken: 'auth/cdc',
            },
        },
    },
};

export interface AimoOccConfig extends OccConfig {
    backend?: AimoBackendConfig;
}

export interface AimoBackendConfig extends BackendConfig {
    occ?: {
        baseUrl?: string;
        prefix?: string;
        useWithCredentials?: boolean;
        endpoints?: AimoOccEndpoints;
    }
}

export interface AimoOccEndpoints extends OccEndpoints {
    cdcToken?: string;
}
